import { render, staticRenderFns } from "./HighlightCard.vue?vue&type=template&id=a36c668e&scoped=true&"
import script from "./HighlightCard.vue?vue&type=script&lang=ts&"
export * from "./HighlightCard.vue?vue&type=script&lang=ts&"
import style0 from "./HighlightCard.vue?vue&type=style&index=0&id=a36c668e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36c668e",
  null
  
)

export default component.exports